// extracted by mini-css-extract-plugin
module.exports = {"pagenav":"pagination-module--pagenav--3BDkR","pagenav__item":"pagination-module--pagenav__item--2lvyU"};